export default function getHeaders () {
  const sessionConfig = JSON.parse(sessionStorage.getItem('config'))
  if (sessionConfig && sessionConfig.headers) return sessionConfig.headers

  return {
    client_id: getClientID()
  }
}

function getClientID () {
  const regExId = /client_id=([^&,#,/]+)/.exec(window.location.href)
  if (regExId) {
    saveCookie('client_id', regExId[1])
    return regExId[1]
  }

  if (getCookie('client_id')) return getCookie('client_id')

  return process.env.VUE_APP_CLIENT_ID
}

function saveCookie (key, value) {
  const today = new Date()
  const expiredDate = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate() + 1
  )

  document.cookie = `${key}=${value};expires=${expiredDate};path=/;domain=ciclic.com.br`
}

function getCookie (key) {
  const cookie = document.cookie.split(';').find((c) => c.match(`${key}=`))
  return cookie ? new RegExp(`${key}=(.+)`).exec(cookie)[1] : false
}
